// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_81-3";
export var contentContainer = "_81-0";
export var editorContainer = "_81-1";
export var quillInputForm = "_81-2";
export var zoneDivider = "_81-4";